import { render, staticRenderFns } from "./Edit_promotion_mobile.vue?vue&type=template&id=89306752&"
import script from "./Edit_promotion_mobile.vue?vue&type=script&lang=js&"
export * from "./Edit_promotion_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports